export const domChatContainerId = "chat-container";
export const domChatScrollId = "chat-scroll-bottom";
export const domChatScrollContainerId = "chat-area";
